import { isLowEndDevice } from "../../utils/models";

export const MIN_SEARCH_CHARS = 3;

export const MAX_SEARCH_CHARS = 50;

export const SEARCH_DEBOUNCE_MS = 300;

export const SEARCH_MODE = {
    ENTER: "enter",
    DEBOUNCE: "debounce",
};

// Low-end devices (Xumo and anything isLowEndDevice() flags) can't afford per-letter
// re-searches, so they search on Enter only. Everything else searches incrementally.
export function getSearchPolicy() {
    return {
        mode: isLowEndDevice() ? SEARCH_MODE.ENTER : SEARCH_MODE.DEBOUNCE,
        minChars: MIN_SEARCH_CHARS,
        debounceMs: SEARCH_DEBOUNCE_MS,
    };
}
